export const CONFIRM_ORDER_INDEX = 2;
